import { useTranslation } from "react-i18next";
import Filter from "../../Filter/Filter";
import { useSelector } from "react-redux";


const DocumentRepositoryFilter = ({ initialFilters, applySearchFilter, initialItemsPage }) => {
  const { t } = useTranslation();
  const loaded = useSelector((state) => state.documentRepository.loaded);
  const contracts = useSelector((state) => state.documentRepository.contracts);

  const documentRepositoryCategories = [
    { type: "text",         category: "name",     title: t("common:text.filter_document_repository_name"),      renderText: t("common:text.filter_document_repository_name"), helper: "document", searchField: "name" },
    { type: "autocomplete", category: "contract", title: t("common:text.filter_document_repository_contract"),     renderText: t("common:text.filter_document_repository_contract"), helper: "12345", additionalData: contracts ?? [], searchField: "contract_name" },
    { type: "date",         category: "period",   title: t("common:text.filter_document_repository_period_title"), renderText: t("common:text.filter_document_repository_period_renderText"), searchField: "create_date" },
  ]

  return (
    <Filter
      categories={documentRepositoryCategories}
      applySearchFilter={applySearchFilter}
      disableApply={!loaded}
      initialFilters={initialFilters}
      initialItemsPage={initialItemsPage}
    />
  )
}

export default DocumentRepositoryFilter;
